import { Typography, Stack } from "@mui/material"
import styles from "./ISUnderConstruction.module.css"

type ISUnderConstructionProps = {
    title: string,
    error: string,
}

export const ISUnderConstruction = (props: ISUnderConstructionProps) =>{
    return <>
        <Stack direction='column' alignItems='center'>
            <Typography className={styles.title} variant="h4">{props.title}</Typography>
            <Typography className={styles.text} variant="h6">{props.error}</Typography>
        </Stack>
    </>
}